export default {
  postingGroups: (state) => state.postingGroups,
  postBatches: (state) => state.postBatches
}
